// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".layerPopUp[data-v-6852943e]{position:fixed;top:0;right:0;bottom:0;left:0;z-index:8}.stickerIcon[data-v-6852943e]{transform-origin:top;animation:stickerIconAni-6852943e 3s linear infinite}@keyframes stickerIconAni-6852943e{0%,50%,to{transform:rotate(0deg)}5%,15%,25%,35%,45%,55%,65%,75%,85%,95%{transform:rotate(4deg)}10%,20%,30%,40%,50%,60%,70%,80%,90%{transform:rotate(-4deg)}}", ""]);
// Exports
module.exports = exports;
